export default [
  {
    path: '/admin/pension-contribution-wages',
    name: 'pension-contribution-wages',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/payroll/pension-contribution-wage/index.vue')
  }
]
